import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic, faCog, faClock, faHashtag, faVideo, faUsers, faBullhorn, faChartLine } from '@fortawesome/free-solid-svg-icons';

const AIRecommendations: React.FC = () => {
  return (
    <section id="ai-recommendations" className="mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center">
              <FontAwesomeIcon icon={faMagic} className="text-white" />
            </div>
            <h2 className="text-xl font-semibold text-white">AI Önerileri</h2>
          </div>
          <button className="text-white/50 hover:text-white transition-colors">
            <FontAwesomeIcon icon={faCog} />
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div className="p-4 bg-gradient-to-r from-purple-600/10 to-purple-400/10 border border-purple-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-purple-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faClock} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-purple-400 font-medium mb-1">Optimal Paylaşım Programı</h4>
                  <p className="text-white/80 text-sm mb-3">
                    Maksimum etkileşim için Salı günleri saat 19:00'da paylaşın. Kitleniz bu saatte en aktif.
                  </p>
                  <button className="bg-purple-600/20 text-purple-400 px-3 py-1 rounded-lg text-sm hover:bg-purple-600/30 transition-colors">
                    Paylaşım Planla
                  </button>
                </div>
              </div>
            </div>

            <div className="p-4 bg-gradient-to-r from-blue-600/10 to-blue-400/10 border border-blue-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faHashtag} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-blue-400 font-medium mb-1">Trend Hashtag'ler</h4>
                  <p className="text-white/80 text-sm mb-3">
                    #TechTrends2024 ve #AIInnovation kullanarak nişinizde %23 daha fazla potansiyel takipçiye ulaşın.
                  </p>
                  <button className="bg-blue-600/20 text-blue-400 px-3 py-1 rounded-lg text-sm hover:bg-blue-600/30 transition-colors">
                    Hashtag'leri Kopyala
                  </button>
                </div>
              </div>
            </div>

            <div className="p-4 bg-gradient-to-r from-green-600/10 to-green-400/10 border border-green-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faVideo} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-green-400 font-medium mb-1">İçerik Formatı</h4>
                  <p className="text-white/80 text-sm mb-3">
                    Kısa videolar, kitlenizin demografisi için statik görsellerden 3.2 kat daha fazla etkileşim alıyor.
                  </p>
                  <button className="bg-green-600/20 text-green-400 px-3 py-1 rounded-lg text-sm hover:bg-green-600/30 transition-colors">
                    Video Oluştur
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="p-4 bg-gradient-to-r from-pink-600/10 to-pink-400/10 border border-pink-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-pink-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faUsers} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-pink-400 font-medium mb-1">Kitle Etkileşimi</h4>
                  <p className="text-white/80 text-sm mb-3">
                    Etkileşimi %45 artırmak için yorumlara 2 saat içinde yanıt verin. Otomatik yanıt kurmayı düşünün.
                  </p>
                  <button className="bg-pink-600/20 text-pink-400 px-3 py-1 rounded-lg text-sm hover:bg-pink-600/30 transition-colors">
                    Otomasyon Kur
                  </button>
                </div>
              </div>
            </div>

            <div className="p-4 bg-gradient-to-r from-yellow-600/10 to-yellow-400/10 border border-yellow-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faBullhorn} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-yellow-400 font-medium mb-1">Çapraz Platform Stratejisi</h4>
                  <p className="text-white/80 text-sm mb-3">
                    Instagram içeriklerinizi LinkedIn için uyarlayarak sektörünüzde 18K+ profesyonel kişiye ulaşın.
                  </p>
                  <button className="bg-yellow-600/20 text-yellow-400 px-3 py-1 rounded-lg text-sm hover:bg-yellow-600/30 transition-colors">
                    Çapraz Paylaş
                  </button>
                </div>
              </div>
            </div>

            <div className="p-4 bg-gradient-to-r from-cyan-600/10 to-cyan-400/10 border border-cyan-400/20 rounded-xl">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-cyan-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faChartLine} className="text-black text-sm" />
                </div>
                <div className="flex-1">
                  <h4 className="text-cyan-400 font-medium mb-1">Büyüme Fırsatı</h4>
                  <p className="text-white/80 text-sm mb-3">
                    "AI meraklıları" segmentini hedefleyin - içerik türünüz için %60 daha yüksek dönüşüm oranlarına sahipler.
                  </p>
                  <button className="bg-cyan-600/20 text-cyan-400 px-3 py-1 rounded-lg text-sm hover:bg-cyan-600/30 transition-colors">
                    Hedef Kitle
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIRecommendations;
